export { default } from './TabGroupBoleto';
